
import Swiper from 'vux/src/components/swiper/swiper.vue'
import GroupTitle from 'vux/src/components/group-title/index.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Divider from 'vux/src/components/divider/index.vue'

import {detail,count,countByOpenid,productParameter} from '@/base/js/api'
let bannerSrc = require('@/assets/images/test1.png')
const imgList = [
bannerSrc,
bannerSrc,
bannerSrc
];

export default {
name: 'app',
data() {
return {
isGenerate:false,//页面加载完才可以进入海报，当页面未加载完，生成海报不能点击
isIndex:0,
allocationIndex:0,
data:{},
isPoster:true,
isScSpecList:true,
posterId:'',
zw:false,
swHeight:'4rem',
serviceUrl:'',
productParameter:{},
miniprogram:localStorage.getItem("miniprogram")
}
},
created(){
this.$vux.loading.show({
text: '加载中...'
})
let param = {
productId: this.$route.query.productId
}
this.serviceUrl=`http://ytkf.yutong.com:8880/live800/chatClient/chatbox.jsp?companyID=8973&configID=7&enterurl=${window.location.href}&pagereferrer=${document.referrer}`
if(this.$route.query.posterId){


this.posterId = this.$route.query.posterId
console.log(this.$route.query.posterId)
this.isPoster = false;












this._wxTool.auth();
let countParam  = {
memberProductPostId : this.posterId,
accessToken:this._wxTool.getAccessToken()
}
countByOpenid(countParam).then(res=>{
if(res.code==0){

}else{
console.log(res.msg)

}
})

}
detail(param).then(res=>{
if(res.code == 0){
console.log(res);
this.$vux.loading.hide()
this.data = res.data.product
this.isGenerate = true
console.log(this.data.categoryList);
if(this.data.scRelationCaseList==0){
console.log(this.data.scRelationCaseList.length)
this.zw = true
}
console.log(this.zw)
if(this.data.scSpecList.length==0){
this.isScSpecList = false
}
var shareTitle=this.data.productName+'宇通推广大使';
this._wxTool.setShare(this.data.basePic,shareTitle);
}else{
this.$vux.toast.text(res.msg, 'middle')
}
})
productParameter(param).then(res=>{
if(res.code==0){
this.productParameter = res.data
}else{
this.$vux.toast.text(res.msg, 'middle')
}
})
},
components: {
Swiper,
SwiperItem,
GroupTitle,
XButton,
Divider
},
methods: {
tabShow(e){
let index = e,isIndex=this.isIndex
if(index==isIndex){
this.isIndex=0
return
}
this.isIndex=e
},
generate(){
/***应当优化为：一气呵成***/
if(null==this._wxTool.getUser()){
this.$vux.toast.text('亲，生成海报前，必须先授权微信，并且登陆哦', 'middle')
this._wxTool.auth();

}else  if(null==this._wxTool.getMember() ){
console.log('need login');
this.$vux.toast.text('亲，生成海报前，必须先登陆哦！', 'middle')
this.$router.push('/login')

}else{
console.log(this.data)
if(!this.isGenerate){
this.$vux.toast.text('亲，页面正在加载哦，请稍后再试！', 'middle')
return
}
let posterInfo = {
productId:this.$route.query.productId,
productName:this.data.productName,
productDescribe:this.data.seoDescription,
recommendReason:this.data.scProductReasonList,
productPicUrl:this.data.basePic,
postImgUrl:this.data.scPoster,
accessToken : this._wxTool.getAccessToken()
}
this.$router.push({name: 'poster', params: {posterInfo:posterInfo}})
}



},
orderCar(){
let categoryName=this.data.categoryList[0].categoryName,
productName = this.data.productName,
categoryId = this.data.categoryList[0].categoryId,
productId = this.$route.query.productId,
posterId = this.$route.query.posterId
this.$router.push({path:'/orderCar',query:{productId:productId,categoryName:categoryName,productName:productName,categoryId:categoryId,posterId:posterId}})
},
recommend(){
let categoryName=this.data.categoryList[0].categoryName,
productName = this.data.productName,
categoryId = this.data.categoryList[0].categoryId,
productId = this.$route.query.productId
this.$router.push({path:'/recommend',query:{productId:productId,categoryName:categoryName,productName:productName,categoryId:categoryId}})
}
}
}



// WEBPACK FOOTER //
// ./src/pages/productDetail/productDetail.vue